import { ProjectJobStatsSchema, StatsType } from 'src/types/api/data/stats';
import {
  DailyStatsProps,
  GetProjectStatProps,
  GetStatProps,
  JobStats,
  ProjectDailyJobStats,
} from 'src/types/client/stats';
import { oneMonthAgo, today } from 'src/utils/date';
import { dataApi } from 'src/utils/http';

export const getProjectJobStats = async ({
  projectId,
  modality,
}: GetProjectStatProps): Promise<JobStats> => {
  const statsTypes: StatsType[] = ['total', 'annotation', 'cross'];
  const stats = await Promise.all(
    statsTypes.map(type => getJobStats({ projectId, type, modality }))
  );
  const result = stats.reduce(
    (acc, stat, idx) =>
      !!statsTypes[idx]
        ? {
            ...acc,
            [statsTypes[idx] as string]: stat.project,
          }
        : acc,
    {} as JobStats
  );

  return result;
};

// Get job stat of specific project
export const getJobStats = async ({
  projectId,
  annotatorId,
  type,
  modality,
}: GetStatProps): Promise<ProjectJobStatsSchema> => {
  // TODO: Missing v3 API
  const { data } = await dataApi.get(`/projects/${projectId}/stats/v2/`, {
    params: {
      type: type === 'total' ? '' : type,
      user: annotatorId,
      modality: modality.toLowerCase(),
    },
  });
  return data;
};

export const getDailyJobStats = async ({
  projectId,
  type,
  modality,
  dateFrom,
  dateTo,
}: DailyStatsProps): Promise<ProjectDailyJobStats> => {
  // TODO: Missing v3 API
  const { data } = await dataApi.get(`/projects/${projectId}/daily-stats/`, {
    params: {
      modality: modality.toLowerCase(),
      type: type === 'total' ? '' : type,
      date_from: dateFrom ? dateFrom : oneMonthAgo,
      date_to: dateTo ? dateTo : today,
    },
  });

  return data;
};
